module.exports = __webpack_public_path__ + "static/media/logout_icon.93278c56.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logout_icon.svg
// module id = 167
// module chunks = 0